import { Skeleton, VStack } from '@vidahealth/vida-ui';

import { SelectableRowSkeleton } from '@/modules/ui';

/**
 * Private to ProgramMatchingScreen — the loading placeholder, laid out to match
 * the real list (a "Recommended for you" group with one row, then an "Other
 * options" group) so the content doesn't shift when the catalog lands. The
 * section titles are skeleton bars too, matching the heading position/size.
 */
export function ProgramListSkeleton() {
  return (
    <VStack space='4xl'>
      <VStack space='lg'>
        <Skeleton variant='rounded' className='h-4 w-40' />
        <SelectableRowSkeleton variant='avatar_and_text' count={1} rowHeight={96} />
      </VStack>

      <VStack space='lg'>
        <Skeleton variant='rounded' className='h-4 w-32' />
        <SelectableRowSkeleton variant='avatar_and_text' count={4} rowHeight={96} />
      </VStack>
    </VStack>
  );
}
